import Api from "./api"

class MsGraphApi {
    // https://graph.microsoft.com/v1.0/users/7a50aeaa-bcc4-4835-abe1-d84d9fb847af?$select=department,displayName,givenName,surname,mail,companyName
    async getInformation(
        endpoint: string,
        token: string,
        selectInformation: string[]
    ): Promise<Record<string, unknown> | unknown[]> {
        let information: Record<string, unknown> | unknown[] = []

        const headers = new Headers()
        const bearer = `Bearer ${token}`
        const parsedSelect = selectInformation.join(',')

        headers.append('Authorization', bearer)

        try {
            // Construct full endpoint with query params
            const fullEndpoint = `${endpoint}?$select=${parsedSelect}`
            information = await Api.get<Record<string, unknown>>(fullEndpoint, undefined, headers)
        } catch (error) {
            console.log(error)
        }

        return information
    }

    async getGroups(token: string): Promise<Record<string, unknown>[]> {
        let groups: Record<string, unknown>[] = []

        const headers = new Headers()
        const bearer = `Bearer ${token}`
        // Note: this.settings is not defined in the original code, might need to be passed as parameter
        const groupsEndpoint = `https://graph.microsoft.com/v1.0/me/memberOf`
        headers.append('Authorization', bearer)

        const options: RequestInit = {
            method: 'GET',
            headers: headers,
        }

        try {
            const response = await fetch(groupsEndpoint, options)
            const json = await response.json()
            groups = json.value
        } catch (error) {
            console.log(error)
        }

        return groups
    }

    async getUserPhoto(token: string): Promise<string | null> {
        const headers = new Headers()
        const bearer = `Bearer ${token}`
        const endpoint = `https://graph.microsoft.com/v1.0/me/photo/$value`
        headers.append('Authorization', bearer)

        const options: RequestInit = {
            method: 'GET',
            headers: headers,
        }

        let photo: string | null = null

        try {
            const response = await fetch(endpoint, options)
            if (!response.ok) {
                throw new Error('Error getting user photo')
            }

            const blob = await response.blob()
            photo = await new Promise<string>((resolve, reject) => {
                const reader = new FileReader()
                reader.onloadend = () => resolve(reader.result as string)
                reader.onerror = reject
                reader.readAsDataURL(blob)
            })
        } catch (error) {
            console.log(error)
        }

        return photo
    }
}

export default new MsGraphApi()
